<template>
    <div class="product-details-container">
      <roof-search :middleContent="false" :rightContent="false" :placeholder="true" v-show="isShowNav"></roof-search>
      <!--图片-->
      <div class="view-img">
<!--        height="2.06667rem"-->
        <van-image fit="cover" :src="cdnUrl+sliderList[currentSliderIndex]" class="img" @click="previewImage"/>
      </div>
      <!-- 轮播 -->
      <div class="swiper-content">
        <div class="btn-prev" :class="currentSliderIndex == 0?'forbid-btn':''">
          <i class="iconfont icon-youjiantou left"></i>
        </div>
<!--        v-if="sliderList.length > 0"-->
        <swiper class="swiper-container" :options="swiperOption" ref="mySwiper" @someSwiperEvent="callback">
          <swiper-slide v-for="(item,index) in sliderList" :key="index">
<!--            <img :src="cdnUrl+item" class="slide-img" alt="">-->
            <van-image fit="cover" :src="cdnUrl+item" class="slide-img" @click="sliderEvent(item, index)"/>
          </swiper-slide>
          <!-- Optional controls -->
<!--          <div class="swiper-pagination"  slot="pagination"></div>-->
<!--          <div class="swiper-button-prev" slot="button-prev"></div>-->
<!--          <div class="swiper-button-next" slot="button-next"></div>-->
<!--          <div class="swiper-scrollbar"   slot="scrollbar"></div>-->
        </swiper>
        <div class="btn-next" :class="currentSliderIndex == sliderList.length-1?'forbid-btn':''">
          <i class="iconfont icon-youjiantou"></i>
        </div>
      </div>
      <!-- 产品简介 -->
      <div class="product-intro" :class="sliderList.length <= 2?'product-margin':''">
        <div class="content">
          <h3 class="product-name">{{detailsObj.title}}</h3>
<!--          <div class="info" :class="clickMore?'':'van-multi-ellipsis&#45;&#45;l2'" v-html="detailsObj.jianjie"></div>-->
          <div class="info" :class="clickMore?'':'van-multi-ellipsis--l2'" v-html="jianjie"></div>
          <button class="bottom-btn-more" @click="moreContent" v-show="introLength >= 50">{{clickMore?'收起':'更多'}}</button>
        </div>
      </div>
      <!-- 标签栏 -->
      <div class="tabs-container">
        <van-tabs v-model="tabsActive"
                  animated
                  :color="tabsColor"
                  @change="tabsChange"
                  :title-active-color="titleActiveColor"
                  :title-inactive-color="titleInactiveColor"
                  line-width="100"
                  line-height="2">
          <van-tab title="产品详情" name="detail">
            <product-details :productDetails="productDetails" ></product-details>
          </van-tab>
          <van-tab title="产品资料" name="means">
            <!-- <product-material :productMaterial="productMaterial" :id="id" @videoChange="videoChange"></product-material> -->
            <product-shopping :productMaterial="productMaterial" :id="id" @videoChange="videoChange"></product-shopping>
          </van-tab>
          <!-- <van-tab title="操作视频" name="operVideo" v-if="this.showVideoId == '112'">
            <product-video :productVideo="productVideo" :id="id" @videoChange="videoChange"></product-video>
          </van-tab> -->
          <van-tab title="产品视频" name="operVideo" v-if="productMaterial.video.length > 0">
            <newProVideo :productVideo="productMaterial" :id="id" @videoChange="videoChange"></newProVideo>
          </van-tab>
          <van-tab title="解决方案" name="solveDetail" v-if="solutionList.length > 0">
            <solution :solutionList="solutionList"></solution>
          </van-tab>
          <van-tab title="技术参数" v-if="false">
            <product-params :productParams="productParams"></product-params>
          </van-tab>
        </van-tabs>
      </div>
      <!-- 底部 -->
      <div class="bottom-operate footer">
        <div class="items" @click="showApplyForm" v-if="detailsObj.form_type">
          <img class="bottom-icon1" src="@/assets/img/bottom-icon1.png" alt="">
          <span class="span-text">{{formType}}</span>
        </div>
        <div class="items" v-if="detailsObj.example_id" @click="goShareDetails(detailsObj.example_id)">
          <img class="bottom-icon2" src="@/assets/img/bottom-icon2.png" alt="">
          <span class="span-text">客户案例分享</span>
        </div>
        <div class="items" v-if="detailsObj.buy_link" @click="goBuy(detailsObj.buy_link)">
          <img class="bottom-icon3" src="@/assets/img/bottom-icon3.png" alt="">
          <span class="span-text">立即购买</span>
        </div>
      </div>
      <!-- 表单 -->
      <apply-form ref="applyForm"></apply-form>
      <!-- 客服 -->
      <client-service></client-service>

      <!-- 视频播放 -->
      <van-overlay :show="showVideo" @click="hideVideoMsg" class="van-overlayes">
        <div class="dplayer-containers" @click.stop>
          <div id="dplayer" class="video-container"></div>
        </div>
<!--        <div class="video-play">-->
<!--&lt;!&ndash;          poster="https://cdn.juplus.cn/FgJdYz67BqwyHtIBYiUb0gkS5h_v"&ndash;&gt;-->
<!--          <video v-if="showVideo" id="aboutType1_video" width="100%" class="video" controls x5-video-player-type="h5" playsinline webkit-playsinline>-->
<!--            <source :src="cdnUrl+videoUrl" type="video/mp4">-->
<!--          </video>-->
<!--        </div>-->
      </van-overlay>
    </div>
</template>

<script>

import 'swiper/dist/css/swiper.css'
import details from './mixins/details'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import roofSearch from '@/components/roof-search'
import productVideo from './components/product-video.vue'
import newProVideo from './components/new-pro-video.vue'
import productDetails from './components/product-details'
// import productMaterial from './components/product-material'
import productShopping from './components/product-shopping'
import solution from './components/solution'
import productParams from './components/product-params'
import applyForm from './components/apply-form'
import clientService from './components/client-service'
import { ImagePreview } from 'vant'
import { recordUserTrack } from '@/libs/common'
// import 'dplayer/dist/DPlayer.min.css'
import DPlayer from 'dplayer'
import { wxShare } from '@/libs/wxjssdk'
let vm = null

export default {
    mixins: [details],
    components: {
        roofSearch,
        swiper,
        swiperSlide,
        productVideo,
        newProVideo,
        productDetails,
        // productMaterial,
        productShopping, // 产品商城组件（产品）
        productParams,
        applyForm,
        clientService,
        solution
    },
    computed: {
        // swiper () {
        //   return this.$refs.mySwiper.swiper
        // }
    },
    data () {
        return {
          showVideoId: '', // 显示移液器的视频
            id: '', // 产品id
            dp: {},
            swiperOption: {
                slidesPerView: 3,
                spaceBetween: 5,
                centeredSlides: true,
                loop: true,
                autoplay: false, // 自动切换
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.btn-next',
                    prevEl: '.btn-prev'
                },
                on: {
                    tap () {
                        const { realIndex } = this
                        vm.handleClickSlide(realIndex)
                    },
                    slideChange () {
                        vm.slideChange(this.realIndex)
                    }
                }
            },
            sliderList: [],
            currentSliderIndex: 0, // 当前slider图片下标
            tabsColor: '#005b9f', // 标签栏背景色
            tabsActive: 'detail', // 标签栏选中的下标
            titleActiveColor: '#005b9f', // 标签栏标题栏选中颜色
            titleInactiveColor: '#9d9d9d', // 标签栏标题默认颜色
            clickMore: false, // 是否单击了更多
            formType: '',
            shareDesc: '产品详情', // 分享描述
            solutionList: [], // 关联的解决方案
        }
    },
    watch: {
        'detailsObj.form_type': {
            handler (newVal, oldVal) {
                var formType = JSON.parse(newVal || '[]')
                if (formType.length === 2) {
                    this.formType = '申请Demo/样品'
                } else {
                    // console.log(form_type[0], 666666)
                    if (formType[0] === '1') {
                        this.$refs.applyForm.type = 1
                        this.$refs.applyForm.navList = [{
                            id: 1,
                            title: '申请Demo'
                        }]
                        this.formType = '申请Demo'
                    } else if (formType[0] === '2') {
                        this.$refs.applyForm.type = 2
                        this.$refs.applyForm.navList = [{
                            id: 2,
                            title: '申请样品'
                        }]
                        this.formType = '申请样品'
                    }
                }
                // console.log('监听obj属性b的变化', newVal)
            }
        },
        // $route: {
        //   handler: function(val, oldVal){
        //     console.log('路由变化',val);
        //     console.log('旧的路由变化',oldVal);
        //   },
        //   // 深度观察监听
        //   deep: true
        // }
    },
    created () {
        
        vm = this
        var query = this.$route.query
        this.id = query.id || ''
        this.showVideoId = query.showid || ''
        this.isShowNav = query.isShowNav || false
        this.tabsActive = query.tabShow
        console.log('信息', this.tabsActive)
        switch (this.tabsActive) {
          case 'detail':
            this.shareDesc = '产品详情'
            break;
          case 'means':
            this.shareDesc = '产品资料'
            break;
          case 'operVideo':
            this.shareDesc = '产品视频'
            break;
          case 'solveDetail':
            this.shareDesc = '解决方案'
            break;
          default:
            this.shareDesc = '产品详情'
        }
         
        // this.testing = this.$store.state.user.testing
        this.$toast.loading({
            message: '加载中...',
            forbidClick: true,
            duration: 0
        })
        
        this.sharePage()
    },
    mounted () {
      this.getProductDetailsPort()
        // current swiper instance
        // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
        // console.log('this is current swiper instance object', this.swiper)
        // this.swiper.slideTo(3, 1000, false)
        
    },
    activated () {
      var query = this.$route.query
      this.tabsActive = query.tabShow
    },
    
    methods: {
      changeKeepAlive (parentName, name, keepAlive) {
        // @ts-ignore
        
        this.$router.options.routes.map((item) => {
          // console.log('外层循环',item);
          if (item.name === parentName) {
            item.meta.keepAlive = keepAlive
            // item.children.map((a) => {
            //   console.log('内层循环',a);
            //   if (a.name === name) {
            //     a.meta.keepAlive = keepAlive
            //   }
            // })
          }
        })
        console.log('缓存',this.$router.options.routes);
      },
      tabsChange (val) {
        // console.log('切换tab',val);
        if (val == 'detail') {
          this.shareDesc = '产品详情'
        } else if (val == 'means') {
          this.shareDesc = '产品资料'
        } else if (val == 'operVideo') {
          this.shareDesc = '产品视频'
        } else if (val == 'solveDetail'){
          this.shareDesc = '解决方案'
        }
        this.sharePage()
      },
      sharePage () {
          const params = {
              title: this.detailsObj.title, // 分享标题
              desc: this.shareDesc, // 分享描述
              link: `${window.location.href.split('#')[0]}#/productDetails?id=${this.id}&tabShow=${this.tabsActive}&showid=${this.showVideoId}`, // 分享链接
              imgUrl: `${this.cdnUrl}${this.detailsObj.cover_img}` // 分享图标
          }
          console.log('分享标题',this.detailsObj,'分享描述',this.shareDesc,'分享链接',params.link);
          // console.log('图片',`${this.cdnUrl}${this.detailsObj.cover_img}`);
          wxShare(params)
        },
        dplayerOption (videoUrl, pic) {
            const dp = new DPlayer({
                container: document.getElementById('dplayer'),
                // screenshot: false,
                autoplay: true,
                video: {
                    url: videoUrl || '',
                    pic: pic || '',
                    thumbnails: 'thumbnails.jpg'
                }
                // subtitle: {
                //   url: 'webvtt.vtt'
                // }
                // danmaku: {
                //   id: 'demo',
                //   api: 'https://api.prprpr.me/dplayer/'
                // }
            })
            this.dp = dp
        },
        // 隐藏video蒙版
        hideVideoMsg () {
            this.showVideo = false
            this.dp.pause()
            this.dp.fullScreen.cancel('web') // 退出全屏
        },
        handleClickSlide (realIndex) {
        // console.log('单击了', realIndex)
        },
        callback () {
            console.log('回调', 666)
        },
        sliderEvent (item, index) {
            // console.log(item, index)
            this.currentSliderIndex = index
        },
        slideChange (realIndex) {
            // console.log(666, realIndex, this.sliderList)
            this.currentSliderIndex = realIndex
        },
        // 显示申请表单
        showApplyForm () {
            this.$refs.applyForm.product_id = this.id
            this.$refs.applyForm.showApplyForm()
        },
        // 单击了更多内容
        moreContent () {
            this.clickMore = !this.clickMore
        },
        // 单击 预览图片
        previewImage (url) {
            console.log(this.currentSliderIndex)
            var images = []
            this.sliderList.map((val) => {
                images.push(this.cdnUrl + val)
            })
            ImagePreview({
                images: images,
                startPosition: this.currentSliderIndex
            })
        // this.$wx.previewImage({
        //   current: url, // 当前显示图片的http链接
        //   urls: [url] // 需要预览的图片http链接列表
        // })
        },
        // 单击跳转案例详情
        goShareDetails (id) {
            this.$router.push(
                {
                    name: 'caseDetail',
                    query: {
                        id: id
                    }
                }
            )
        },
        // 根据购买链接跳转
        goBuy (link) {
            window.location.href = link
            var params = {
                model: 'buy_product',
                model_id: this.id,
                user_id: this.$store.state.user.id,
                title: `点击了【${this.detailsObj.title}】产品购买`,
                action: 'click_buy'
            }
            recordUserTrack(params) // 记录用户轨迹
        }
    }
}
</script>

<style lang="scss">

.product-details-container{
  padding-bottom: rem(60);
  background: #fff;
  .view-img{
    width: 100%;
    height: rem(220);
    background: #f7f8fa;
    .img{
      width: 100%;
      height: 100%;
    }
  }
  .swiper-content{
    width: 100%;
    height: rem(100);
    padding: 0 rem(20);
    display: flex;
    align-items: center;
    .swiper-container {
      width: 100%;
      height: 100%;
      .slide-img{
        width: 100%;
      }
    }
    .swiper-slide {
      text-align: center;
      font-size: 18px;
      background: #fff;

      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
      transition: 300ms;
      transform: scale(0.8);
    }
    .swiper-slide-active,.swiper-slide-duplicate-active{
      transform: scale(1);
    }
    .btn-prev,.btn-next{
      width: rem(18);
      height: rem(37);
      background: $base-color;
      border-radius: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      outline: none;
      border: none;
      .icon-youjiantou{
        font-size: 20px;
        font-weight: bold;
      }
      .left{
        transform: rotate(-180deg);
      }
    }
    .btn-prev{
      margin-right: rem(7);
    }
    .btn-next{
      margin-left: rem(7);
    }
    .forbid-btn{
      background: #e4e0e0;
    }
  }
  .product-intro{
    padding: 0 rem(20);
    .content{
      background: #dee5ed;
      padding: rem(10) rem(20) rem(20);
      border-radius: 2px;
      .product-name{
        font-size: 15px;
        /*height: rem(35);*/
        line-height: rem(25);
      }
      .info{
        color: #333333;
        font-size: 12px;
        line-height: rem(20);
        word-break: break-word;
      }
      .van-multi-ellipsis--l2{
        transition: all .2s;
      }
      .bottom-btn-more{
        width: rem(72);
        height: rem(28);
        display: block;
        margin: 0 auto;
        margin-top: rem(20);
        border: 1px solid #2c2c2c;
        font-size: 13px;
        background: none;
        color: #2c2c2c;
        border-radius: 2px;
      }
    }
  }
  .product-margin{
    margin-top: rem(20);
  }
  .tabs-container{
    .van-tab{
      font-size: 15px;
    }
    .van-tab--active{
      font-weight: bold;
    }
    .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
      /*border-width: 0;*/
      /*border-bottom: 1px solid ;*/
      border-top: 0 solid;
      border-bottom: 1px solid #eaeaea;
    }
  }
  .bottom-operate{
    display: flex;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 999;
    .items{
      flex: 1;
      height: rem(50);
      background: $base-color;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      color: #fff;
      font-size: 12px;
      position: relative;
      &:active{
        background: #51c0dc;
      }
      &:not(:last-child)::after{
        content: '';
        position: absolute;
        width: 1px;
        height: rem(28);
        background: #fff;
        top: 50%;
        right: 0;
        margin-top: rem(-14);
      }
      .bottom-icon1{
        width: rem(25);
        height: rem(25);
      }
      .bottom-icon2{
        width: rem(21);
        height: rem(25);
      }
      .bottom-icon3{
        width: rem(26);
        height: rem(24);
      }
      .span-text{
        margin-top: rem(3);
      }
    }
  }
  .van-overlayes{
    z-index: 9999;
    .dplayer-containers{
      position: absolute;
      top: 45%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 90%;
      margin: 0 auto;
      .video-container{
        width: 100%;
        height: 280px;
      }
    }
  }
  .video-play{
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    z-index: 999;
    video{
      height: rem(220);
    }
  }
}
</style>
